import {
    Flex,
    Label,
    LayoutBox,
    TextField,
} from '@bamboohr/fabric';
import { QuestionPopover } from '../question-popover/question-popover';

/**
 * Props for the Exemptions component
 */
export type ExemptionsProps = {
    /** disables the form field */
    disabled: boolean;
    /** disables the form field and determines the placeholder text */
    ignore: boolean;
    /** the label for the field */
    label: string;
    /** the value of the field */
    value: string;
};

/**
 * Exemptions Component
 * 
 * Renders a number field for exemptions.
 * 
 */
export const Exemptions = ({
    disabled,
    ignore,
    label = $.__('Exemptions'),
    value = '',
}: ExemptionsProps) => {
    return (
        <LayoutBox>
            <Flex flexDirection="column">
                <Flex gap={1}>
                    <Label 
                        disabled={ignore || disabled}
                        htmlFor="exemptions"
                    >
                        {label}
                    </Label>
                    <QuestionPopover
                        biId="payinfo-taxes-statewh-la-deductions-popover"
                        content={$.__("Your filing status determines your deductions. Update your filing status if you'd like to change your deductions.")}
                        title={$.__("Why can't I adjust my deductions?")}
                    />
                </Flex>
            
                <TextField
                    disabled={ignore || disabled}
                    id="exemptions"
                    name="state[dependents]"
                    placeholder={value === '' || ignore ? 'NA' : value}
                    size="medium"
                    value={ignore ? '' : value}
                    width={3}
                />

                {/*
                    If our field is disabled to prevent user input, we still want the field to be part of the payload.
                    If ignore is true, we want to hide the field from the payload.
                */}
                {disabled || !ignore ? (
                    <input
                        name="state[dependents]"
                        type="hidden"
                        value={value}
                    />
                ) : null}
                
            </Flex>
        </LayoutBox>
    );
};